import { gql } from '@apollo/client';

const LOGIN_MUTATION = gql`
  mutation login($input: LoginInput) {
    login(input: $input) {
      result
    }
  }
`;

export { LOGIN_MUTATION };
